import { sortKind } from "fast-fuzzy";
import {
  Form1099Status,
  ICollaboratorSchema
} from "@wingspanhq/payments/dist/interfaces";
import { wsSearch } from "@wingspanhq/fe-component-library";

import { getCurrentYearForm1099Balances } from "../../../query/payments/selectors";

export enum DashboardScope {
  All = "all",
  NeedsAction = "needs-action",
  Ready = "ready",
  Submitted = "submitted",
  Exlduded = "excluded"
}

const getSearchedCollaborators = (
  searchText: string,
  collaborators: ICollaboratorSchema[]
) =>
  wsSearch(searchText, collaborators, {
    normalizeWhitespace: true,
    ignoreCase: true,
    keySelector: collaborator =>
      [
        collaborator.member.user.profile?.firstName,
        collaborator.member.user.profile?.lastName,
        collaborator.member.user.email,
        collaborator.member.profile?.company?.name,
        collaborator.collaboratorId,
        collaborator.labels.contractorId
      ]
        .filter(Boolean)
        .join(" ")
        .trim(),
    threshold: 0.7,
    sortBy: sortKind.bestMatch
  });

const SCOPE_STATUSES: { [key in DashboardScope]: Form1099Status[] } = {
  [DashboardScope.All]: [
    Form1099Status.Accepted,
    Form1099Status.NeedsActionDispute,
    Form1099Status.NeedsActionInfo,
    Form1099Status.Ready,
    Form1099Status.Rejected,
    Form1099Status.Submitted
  ],
  [DashboardScope.NeedsAction]: [
    Form1099Status.NeedsActionInfo,
    Form1099Status.NeedsActionDispute
  ],
  [DashboardScope.Ready]: [Form1099Status.Ready],
  [DashboardScope.Submitted]: [
    Form1099Status.Submitted,
    Form1099Status.Accepted,
    Form1099Status.Rejected
  ],
  [DashboardScope.Exlduded]: [Form1099Status.Excluded]
};

const getCollaboratorsForScope = (
  scope: DashboardScope,
  collaborators: ICollaboratorSchema[]
) =>
  collaborators.filter(collaborator => {
    const currentForm1099Balances = getCurrentYearForm1099Balances(
      collaborator
    );

    const currentFormStatus = currentForm1099Balances?.status;

    return currentFormStatus
      ? SCOPE_STATUSES[scope].includes(currentFormStatus)
      : true;
  });

function getCollaborators(
  searchText: string,
  dashboardScope: DashboardScope,
  allCollaborators: ICollaboratorSchema[]
) {
  const searchedCollaborators = searchText
    ? getSearchedCollaborators(searchText, allCollaborators)
    : allCollaborators;

  return getCollaboratorsForScope(dashboardScope, searchedCollaborators);
}

export default getCollaborators;
